(() => {
  'use strict';
  window.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a#cart-icon-bubble');
    if (!link || !document.body.classList.contains('fw-native-fallback')) return;
    if (document.querySelector('cart-drawer,cart-notification,[id*="CartDrawer"]')) return;
    const target = (link.getAttribute('target') || '').trim().toLowerCase();
    if ((target && target !== '_self') || link.hasAttribute('download') || !link.getAttribute('href')) return;
    // A legacy/app click handler can swallow this link when no cart panel is mounted.
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
})();
